import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import React from 'react';

import IWorkspace from '../../types/IWorkspace';
import WsColors from '../../WsColors';
import { Item } from '../Item';
import { WsButton } from '../WsButton';
import { WsTypography, WsTypoColors, WsTypoVariants } from '../WsTypography';

const WorkspaceAvatar = styled(Avatar)(() => ({
  textTransform: 'uppercase',
  marginTop: '7px',
}));
interface IWorkspaceListing {
  workspace: IWorkspace;
  expireNotification(args: IWorkspace): JSX.Element | undefined;
  openWorkspace(args: IWorkspace): void;
  isAvatarColorBlue: boolean;
}

const WorkspaceCard: React.FC<IWorkspaceListing> = ({
  workspace,
  openWorkspace,
  isAvatarColorBlue,
}) => {
  const getFrontInitialInAvatar = () => {
    if (workspace.name) {
      const workspaceName = workspace.name;
      const acronym = workspaceName ? workspaceName.match(/\b(\w)/g) : null;
      return acronym ? acronym.join('').toUpperCase() : '';
    }
    return '';
  };

  const extractCompanyDomain = () => {
    if (workspace.ownerId) {
      const email = workspace.ownerId;
      return email ? email.split('@')[1] : '';
    }
    return '';
  };

  return (
    <Card variant="outlined" sx={{ marginBottom: '12px' }}>
      <Grid container direction="row" spacing={0}>
        <Grid container item xs={9} direction="row" spacing={0}>
          <Grid item>
            <Item>
              <WorkspaceAvatar
                sx={{
                  background: isAvatarColorBlue ? WsColors.TheBlues100 : WsColors.Yellow100,
                  color: isAvatarColorBlue ? WsColors.TheBlues400 : WsColors.Yellow500,
                }}
                variant="rounded"
              >
                {getFrontInitialInAvatar()}
              </WorkspaceAvatar>
            </Item>
          </Grid>
          <Grid item>
            <Item>
              <WsTypography variant={WsTypoVariants.SUB_TITLE}>
                {workspace.name ? workspace.name : ''}
              </WsTypography>
              <WsTypography variant={WsTypoVariants.BODY1}>{extractCompanyDomain()}</WsTypography>
            </Item>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Item sx={{ paddingLeft: '0px' }}>
            <WsButton variant="outlined" onClick={() => openWorkspace(workspace)}>
              {workspace.accepted || workspace.owns ? 'Open' : 'Join'}
            </WsButton>
          </Item>
        </Grid>
      </Grid>
      <Stack direction="column" sx={{ background: WsColors.TheBlues25 }}>
        <Item>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.SENARY}>
            {workspace.ownerName ? workspace.ownerName + ' (owner)' : ''}
          </WsTypography>
          <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.TERTIARY}>
            {workspace.ownerId ? workspace.ownerId : ''}
          </WsTypography>
        </Item>
        {/* {expireNotification(workspace)} */}
      </Stack>
    </Card>
  );
};

export default WorkspaceCard;
